import Model, { attr } from '@ember-data/model';
import classic from 'ember-classic-decorator';

@classic
export default class PracticeWebsiteUploadModel extends Model {
  @attr() uploadType;
  @attr() uploadToken;
}
